import { Chip } from '@mui/material';
import { INGEST_RUN_STATUS_COLORS } from '../../../../../helpers/adsIngestRunsConstants';

export const StatusChip = ({ status, ...chipProps }) => {
  if (!status) return null;
  return <Chip size="small" label={status} color={INGEST_RUN_STATUS_COLORS[status] || 'default'} {...chipProps} />;
};
